import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useMemberAuth } from "../context/MemberAuthContext";
import { toast } from "../hooks/use-toast";
import { ArrowRight, LogIn } from "lucide-react";

const MemberLogin = () => {
  const { member, login } = useMemberAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const nextPath = params.get("next") || "/member";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (member) nav(nextPath, { replace: true }); }, [member, nav, nextPath]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast({ title: "Welcome back" });
      nav(nextPath, { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail || "Invalid credentials";
      toast({ title: "Sign in failed", description: detail });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <form onSubmit={submit} className="w-full max-w-[440px] rounded-lg p-8" style={{ background: '#fbf8ef' }}>
        <div className="w-10 h-10 rounded-md flex items-center justify-center mb-4" style={{ background: '#0f3d2e', color: '#f4efe4' }}><LogIn size={18} /></div>
        <div className="section-eyebrow text-[#0d2a20]/60 mb-2">Members</div>
        <h1 className="hero-title text-[36px] leading-tight mb-2">Member <span className="font-serif-i text-[#e0684d]">sign in</span></h1>
        <p className="text-[13px] text-[#0d2a20]/70 mb-6">Only approved & activated members can sign in.</p>
        <div className="space-y-4">
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Email</label>
            <input required type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <div>
            <label className="text-[12px] text-[#0d2a20]/70">Password</label>
            <input required type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full mt-1 px-3 py-2 rounded-md bg-white border" style={{ borderColor: 'rgba(13,42,32,0.15)' }} />
          </div>
          <button disabled={busy} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md btn-coral text-[14px] disabled:opacity-60">{busy ? "Signing in…" : "Sign in"} <ArrowRight size={14} /></button>
        </div>
        <div className="mt-6 flex items-center justify-between text-[13px]">
          <Link to="/forgot-password" className="link-underline text-[#0d2a20]/80">Forgot password?</Link>
          <div>Not a member? <Link to="/join" className="link-underline text-[#e0684d]">Apply to join</Link></div>
        </div>
      </form>
    </div>
  );
};

export default MemberLogin;
